import SectionHeading from "@/components/base/SectionHeading";
import { reviews } from "@/mocks/homeContent";

export default function Reviews() {
  return (
    <section id="reviews" className="scroll-mt-24 w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="用户反馈"
          title="他们已经装好并开始使用"
          desc="来自不同手机系统的用户反馈，帮助你了解安装过程的常见体验与注意事项。"
          align="center"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {reviews.map((item) => (
            <figure
              key={item.name}
              className="bg-background-50 border border-background-200 rounded-lg p-5 flex flex-col"
            >
              <div className="flex items-center gap-1 text-primary-500">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                ))}
                {Array.from({ length: 5 - item.rating }).map((_, i) => (
                  <i key={`e-${i}`} className="ri-star-line text-sm text-background-300" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-xs md:text-sm leading-relaxed text-foreground-700 grow">
                “{item.text}”
              </blockquote>
              <figcaption className="mt-4 pt-4 border-t border-background-200 flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center text-sm font-medium">
                  {item.name.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-950">{item.name}</p>
                  <p className="text-[11px] text-foreground-500">{item.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}